import React from 'react';
import { useTranslation } from 'react-i18next';
import { Avatar, AvatarSize } from '../../../DesignSystem/VendorProfile/Avatar';
import { useStore } from '../../../store';
import { RoleType, ISummaryData } from '../../../types';
import Heading from '../../../generic-components/Heading';
import { BUSINESS_NAME_APPROVED } from '../consts';
import { DownArrow } from '../../../assets/svg';
import Icon from '../../../generic-components/Icon';
import { LiliPlanBadge } from '../../../DesignSystem/LiliPlanBadge/LiliPlanBadge';

interface IProps {
  isMenuOpen: boolean;
}

export const ProfileTriggerContent = ({ isMenuOpen }: IProps) => {
  const {
    authorizedUserType,
    authorizedUserData,
    customer: { firstName, lastName, customerProfile },
    dba,
    business: { name: businessName },
  }: ISummaryData = useStore((state) => state.summary);
  const { customerId } = useStore((state) => state.user);
  const { t } = useTranslation();

  const modifiedName = ((): string => {
    const customerName = `${firstName} ${lastName}`;
    if (!authorizedUserType) {
      return customerName;
    }
    const authUserName = `${authorizedUserData?.authorizedUserDetails?.firstName} ${authorizedUserData?.authorizedUserDetails?.lastName}`;

    switch (authorizedUserType) {
      case RoleType.ACCOUNTANT:
        return `${authUserName} ${t('PROFILE_ACCOUNTANT_INDICATOR')}`;
      case RoleType.ADMIN:
        return authUserName;
      default:
        return customerName;
    }
  })();
  return (
    <div className='flex items-center gap-[12px] w-full'>
      <Avatar name={businessName || modifiedName} id={customerId} size={AvatarSize.LARGE} />
      <div className='flex flex-col items-start max-w-[75%]'>
        <div className='flex flex-row gap-2 items-center'>
          <Heading
            title={modifiedName}
            className='font-metricRMedium text-action03 text-[1rem] leading-normal max-w-full text-left truncate'
          />
          <LiliPlanBadge planType={customerProfile} />
        </div>

        {dba?.name && dba.status === BUSINESS_NAME_APPROVED && (
          <Heading title={dba.name} className='font-metricR text-[14px] max-w-full truncate text-bw07' />
        )}
      </div>
      <Icon
        className={`absolute right-[20px] top-[50%] translate-y-[-50%] duration-150 ${isMenuOpen ? 'rotate-[180deg]' : 'rotate-0'}`}
        src={DownArrow}
      />
    </div>
  );
};
